import { useEffect, useState } from "react";

const Progress = () => {
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    // Прогресс-анимация
    let start = 0;
    const target = 56;
    const duration = 3000;
    const stepTime = 30;
    const increment = 100 / (duration / stepTime);

    const timer = setInterval(() => {
      start += increment;
      if (start >= target) {
        start = target;
        clearInterval(timer);
      }
      setProgress(Math.floor(start));
    }, stepTime);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <div className="w-full h-full p-2 mb-10 flex flex-col items-center">
      {/* Заголовок */}
      <div className="w-full mb-[60px] text-center">
        <h1 className="text-4xl font-medium bg-gradient-to-r from-[#FC5EB2] to-[#444CE7] bg-clip-text text-transparent mb-10">
          Track your progress
        </h1>
      </div>

      {/* Контейнер с телефоном и эффектом */}
      <div
        className="relative w-full max-w-[500px] h-[550px] 
                bg-white rounded-3xl
                flex flex-col items-center justify-center"
      >
        <img
          loading="lazy"
          className="absolute z-10 xss:w-[80%] xs:w-[60%] mb-10"
          src="/iPhProgress.webp"
          alt="IphLeft"
        />
        {/* SVG-прогресс */}
        <img
          loading="lazy"
          className="absolute translate-x-[50%] translate-y-[-60%] right-2/3 z-10 xss:w-[55%] xs:w-[45%] mb-10"
          src="/circleProgress.png"
          alt="IphLeft"
        />
      </div>
      <h1 className="mt-6 text-center text-xl italic font-normal text-gray-800 max-w-[800px]">
        Track your progress, celebrate results, and{" "}
        <span className="text-pink-400">enjoy your journey</span> to healthier
        skin and hair.
      </h1>
    </div>
  );
};

export default Progress;
